if (!customElements.get('p80-team-drawer')) {
    customElements.define(
        'p80-team-drawer',
        class P80TeamDrawer extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback() {
                this.isOpen = false;
                this.body = document.querySelector('body');
                this.drawerOpener = document.querySelector(`#${this.dataset.target}`);
                this.closeButton = this.querySelector('.p80-team-drawer__close');

                this.body.addEventListener('click', this.closeBody.bind(this));
                this.drawerOpener?.addEventListener('click', this.open.bind(this));
                this.closeButton?.addEventListener('click', this.close.bind(this));
                const tasks = [this.setHeaderCartIconAccessibility.bind(this)];

                this.yieldTasks(tasks);
            }

            disconnectedCallback() {
                this.body.removeEventListener('click', this.closeBody);
                this.drawerOpener?.removeEventListener('click', this.open);
                this.closeButton?.removeEventListener('click', this.handleClose);
            }

            yieldToMain() {
                return new Promise((resolve) => {
                    setTimeout(resolve, 0);
                });
            }

            async yieldTasks(tasks) {
                while (tasks.length > 0) {
                    const task = tasks.shift();
                    task();
                    await this.yieldToMain();
                }
            }

            setAccessibilityOptions() {
                if (this.isOpen) {
                    this.setAttribute('aria-hidden', false);
                    this.setAttribute('tabindex', 0);
                } else {
                    this.setAttribute('aria-hidden', true);
                    this.setAttribute('tabindex', -1);
                    removeTrapFocus();
                }
            }

            open(event) {
                event?.preventDefault();

                setTimeout(() => {
                    this.isOpen = true;
                    this.classList.add('p80-team-drawer--visible');
                    document.body.classList.add('overflow-hidden');
                    this.setAccessibilityOptions();
                });

                this.addEventListener(
                    'transitionend',
                    () => {
                        trapFocus(this, this.closeButton);
                    },
                    { once: true }
                );
            }

            close(e) {
                this.isOpen = false;
                this.classList.remove('p80-team-drawer--visible');
                document.body.classList.remove('overflow-hidden');
                this.body.removeEventListener('click', this.closeBody);
                this.setAccessibilityOptions();
            }

            closeBody(e) {
                if (e.target.closest('p80-team-drawer')) return;
                this.isOpen = false;
                this.classList.remove('p80-team-drawer--visible');
                document.body.classList.remove('overflow-hidden');
                this.body.removeEventListener('click', this.closeBody);
                this.setAccessibilityOptions();
            }

            // Needed for stock Shopify components
            setActiveElement() {}
        }
    );
}
